import store from '@/state/store'

export default [{
        path: '/',
        meta: {
            authRequired: true
        },
        name: 'home',
        component: () => import('../pages/dashboard/index'),
    },
    {
        path: '/dang-nhap',
        name: 'login',
        component: () => import('../pages/auth/auth'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                const loggeduser = localStorage.getItem('user-token');
                if (loggeduser) {
                    // Redirect to the home page instead
                    window.location.href = '/'
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('./views/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({
                        name: 'home'
                    })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('./views/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({
                        name: 'home'
                    })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else {
                    store.dispatch('authfack/logout')
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? {
                    name: 'default'
                } : {
                    ...routeFrom
                })
            },
        },
    },
    {
        path: '/calendar',
        name: 'Calendar',
        component: () => import('./views/calendar/index'),
        meta: {
            authRequired: true,
        },
    },
    {
        path: '/email/inbox',
        name: 'Email Inbox',
        component: () => import('./views/email/inbox'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/email/read-email',
        name: 'Read email',
        component: () => import('./views/email/reademail'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/email/compose',
        name: 'Compose',
        component: () => import('./views/email/compose'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/alerts',
        name: 'Alerts',
        component: () => import('./views/ui/alerts'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/rating',
        name: 'Rating',
        component: () => import('./views/ui/rating'),
        meta: {
            authRequired: true,
        }
    },

    {
        path: '/ui/buttons',
        name: 'Buttons',
        component: () => import('./views/ui/buttons'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/cards',
        name: 'Cards',
        component: () => import('./views/ui/cards'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/carousel',
        name: 'Carousel',
        component: () => import('./views/ui/carousel'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/colors',
        name: 'Colors',
        component: () => import('./views/ui/colors'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/dropdowns',
        name: 'Dropdowns',
        component: () => import('./views/ui/dropdowns'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/general',
        name: 'General',
        component: () => import('./views/ui/general'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/grid',
        name: 'Grid',
        component: () => import('./views/ui/grid'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/images',
        name: 'Images',
        component: () => import('./views/ui/images'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/modals',
        name: 'Modals',
        component: () => import('./views/ui/modals'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/progressbar',
        name: 'Progressbar',
        component: () => import('./views/ui/progressbar'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/rangeslider',
        name: 'Range-slider',
        component: () => import('./views/ui/rangeslider'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/sweetalert',
        name: 'Sweet-alert',
        component: () => import('./views/ui/sweetalert'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/tabs',
        name: 'Tabs & Accordions',
        component: () => import('./views/ui/tabs'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/typography',
        name: 'Typography',
        component: () => import('./views/ui/typography'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/ui/video',
        name: 'Video',
        component: () => import('./views/ui/video'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/timeline',
        name: 'Timeline',
        component: () => import('./views/pages/timeline'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/invoice',
        name: 'Invoice',
        component: () => import('./views/pages/invoice'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/pricing',
        name: 'Pricing',
        component: () => import('./views/pages/pricing'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/blank-page',
        name: 'Blank page',
        component: () => import('./views/pages/blank'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/faqs',
        name: 'FAQs',
        component: () => import('./views/pages/faqs'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/directory',
        name: 'Directory',
        component: () => import('./views/pages/directory'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/404',
        name: 'Page-404',
        component: () => import('./views/pages/error-404'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/500',
        name: 'Page-500',
        component: () => import('./views/pages/error-500'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/maintenance',
        name: 'Maintenance',
        component: () => import('./views/pages/maintenance'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/login-1',
        name: 'Login-1',
        component: () => import('./views/pages/login-1'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/login-2',
        name: 'Login-2',
        component: () => import('./views/pages/login-2'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/register-1',
        name: 'Register-1',
        component: () => import('./views/pages/register-1'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/register-2',
        name: 'Register-2',
        component: () => import('./views/pages/register-2'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/recoverpwd-1',
        name: 'Recover Password 1',
        component: () => import('./views/pages/recoverpwd-1'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/recoverpwd-2',
        name: 'Recover Password 2',
        component: () => import('./views/pages/recoverpwd-2'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/lock-screen1',
        name: 'Lock-screen 1',
        component: () => import('./views/pages/lock-screen1'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/lock-screen2',
        name: 'Lock-screen 2',
        component: () => import('./views/pages/lock-screen2'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/form/elements',
        name: 'Form Elements',
        component: () => import('./views/forms/elements'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/form/advanced',
        name: 'Form advanced',
        component: () => import('./views/forms/advanced'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/form/editor',
        name: 'Form editor',
        component: () => import('./views/forms/editor'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/form/mask',
        name: 'Form mask',
        component: () => import('./views/forms/mask'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/form/uploads',
        name: 'Form uploads',
        component: () => import('./views/forms/uploads'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/form/validation',
        name: 'Form validation',
        component: () => import('./views/forms/validation'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/form/repeater',
        name: 'Form Repeater',
        component: () => import('./views/forms/repeater'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/form/wizard',
        name: 'Form wizard',
        component: () => import('./views/forms/wizard'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/icons/dripicons',
        name: 'Dripicons icons',
        component: () => import('./views/icons/dripicons'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/icons/fontawesome',
        name: 'Font-awesome icons',
        component: () => import('./views/icons/fontawesome'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/icons/ion',
        name: 'Ion icons',
        component: () => import('./views/icons/ion'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/icons/material',
        name: 'Material icons',
        component: () => import('./views/icons/material'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: "/van-ban-di",
        name: "Văn bản đi",
        // meta: {},
        component: () => import("../pages/vanbandi"),
    },
    {
        path: "/tat-ca-van-ban-di",
        name: "Văn bản đi",
        // meta: {},
        component: () => import("../pages/vanbandi/tatCaVanBanDi"),
    },
    {
        path: "/quan-ly-van-ban-di",
        name: "Quản lý văn bản đi",
        // meta: {},
        component: () => import("../pages/vanbandi/quanLyVanBanDi"),
    },
    {
        path: "/ban-hanh-van-ban",
        name: "Văn bản đi",
        // meta: {},
        component: () => import("../pages/vanbandi/banHanhVanBanDi"),
    },
    {
        path: "/xu-ly-van-ban-di",
        name: "Văn bản đi",
        // meta: {},
        component: () => import("../pages/vanbandi/xuLyVanBanDi"),
    },
    {
        path: "/cap-so-van-ban-di",
        name: " Cấp số văn bản đi",
        // meta: {},
        component: () => import("../pages/vanbandi/capSoVanBanDi"),
    },
    {
        path: '/icons/themify',
        name: 'Themify icons',
        component: () => import('./views/icons/themify'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/icons/typicons',
        name: 'Typicons icons',
        component: () => import('./views/icons/typicons'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/tables/basic',
        name: 'Basic table',
        component: () => import('./views/tables/basic'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/tables/advanced',
        name: 'Advanced table',
        component: () => import('./views/tables/advancedtable'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/charts/chartist',
        name: 'Chartist',
        component: () => import('./views/charts/chartist'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/charts/chartjs',
        name: 'Chartjs',
        component: () => import('./views/charts/chartjs/index'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/charts/apex',
        name: 'apex',
        component: () => import('./views/charts/apex'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/charts/echart',
        name: 'Echart chart',
        meta: { authRequired: true },
        component: () => import('./views/charts/echart/index')
    },
    {
        path: '/email-template/basic',
        name: 'Email-template Basic',
        component: () => import('./views/email-template/basic'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/email-template/alert',
        name: 'Alert Email',
        component: () => import('./views/email-template/alert'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/email-template/billing',
        name: 'Billing Email',
        component: () => import('./views/email-template/billing'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/maps/google',
        name: 'Google map',
        component: () => import('./views/maps/google'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/linh-vuc',
        name: 'LinhVuc',
        component: () => import('../pages/linhvuc'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: "/nhom-quyen",
        name: "NhomQuyen",
        meta: {
            authRequired: true,
        },
        component: () => import("../pages/module"),
    },
    {
        path: "/nhom-quyen/action/:id?",
        name: "Hành động",
        // meta: {},
        component: () => import("../pages/module/action"),
    },
    {
        path: "/menu",
        name: "Menu",
         meta: {          authRequired: true, },
        component: () => import("../pages/menu"),
    },
    {
        path: "/vai-tro",
        name: "Quyền",
        meta: {can: 'viewpage-roles'},
        component: () => import("../pages/role"),
    },
    {
        path: "/vai-tro/thiet-lap-quyen/:id?",
        name: "Vai trò",
        meta: {can: 'viewpage-roles' },
        component: () => import("../pages/role/addPermissions01"),
    },
    {
        path: "/add-permissions",
        name: "Test ",
        component: () => import("../pages/role/addPermissions"),
    },
    {
        path: "/tai-khoan",
        name: "Tài khoản",
        meta: {
            can: 'viewpage-user',
        },
        component: () => import("../pages/user"),
    },
    {
        path: "/tai-khoan/doi-mat-khau",
        name: "Đổi mật khẩu",
        meta: {can: 'viewpage-user', },
        component: () => import("../pages/user/ChangePass"),
    },
    {
        path: "/don-vi",
        name: "Đơn vị",
        meta: { },
        component: () => import("../pages/donVi"),
    },
    {
        path: "/loggings",
        name: "Loggings",
        meta: {},
        component: () => import("../pages/loggings"),
    },
    {
        path: "/thong-tin-ca-nhan",
        name: "Thông tin cá nhân",
        // meta: {},
        component: () => import("../pages/auth/profile"),
    },
    {
        path: "/chuc-vu",
        name: "Chức vụ",
        // meta: {},
        component: () => import("../pages/chucVu"),
    },
    {
        path: "/loai-van-ban",
        name: "Loại văn bản",
        // meta: {},
        component: () => import("../pages/loaiVanBan"),
    },
    {
        path: "/trang-thai",
        name: "Trạng thái",
        // meta: {},
        component: () => import("../pages/trangThai"),
    },
    {
        path: "/hinh-thuc-gui",
        name: "Hình thức gửi",
        // meta: {},
        component: () => import("../pages/hinhThucGui"),
    },
    {
        path: "/khoi-co-quan",
        name: "Khối cơ quan",
        // meta: {},
        component: () => import("../pages/khoiCoQuan"),
    },
    {
        path: "/co-quan",
        name: "Cơ quan",
        // meta: {},
        component: () => import("../pages/coQuan"),
    },
    {
        path: "/soan-van-ban-den/:id?",
        name: "soan-van-ban-den",
        //meta: { },
        component: () => import("../pages/vanbandenXL/soanVanBanDen"),
    },
    {
        path: "/van-ban-den",
        name: "Văn bản đến",
        //meta: { },
        component: () => import("../pages/vanbandenXL"),
    },
    {
        path: "/xu-ly-van-ban-den",
        name: "Văn bản đến",
        //meta: { },
        component: () => import("../pages/vanbandenXL/xuLyVanBanDen"),
    },
    {
        path: "/cap-so-van-ban-den",
        name: "Cấp số văn bản đến",
        //meta: { },
        component: () => import("../pages/vanbandenXL/capSoVanBanDen"),
    },
    {
        path: "/thong-bao-van-ban",
        name: " Thông báo van ban",
        // meta: {},
        component: () => import("../pages/thongBao/index"),
    },
    {
        path: "/thong-bao-chung",
        name: " Thông báo chung",
        // meta: {},
        component: () => import("../pages/thongBao/thongBaoChung"),
    }
    ,
    {
        path: "/ky-so",
        name: "Ký số",
        // meta: {},
        component: () => import("../pages/kyso"),
    },
    {
        path: "/loai-trang-thai",
        name: " Loại trạng thái",
        // meta: {},
        component: () => import("../pages/loaiTrangThai"),
    },
    {
        path: "/xac-nhan-ky-so-noi-bo",
        name: " Xác nhận ký số nội bộ",
        // meta: {},
        component: () => import("../pages/xacNhanKySo"),
    },
    {
        path: "/lich-cong-tac/:loaiLichCongTac",
        name: "Lịch công tác",
        // meta: {},
        component: () => import("../pages/lichcongtac/index"),
    },
    {
        path: "/lich-cong-tac-ca-nhan",
        name: "Lịch công tác cá nhân",
        // meta: {},
        component: () => import("../pages/lichcongtac/lichcongtaccanhan"),
    },
    {
        path: "/cong-viec/:id",
        name: "congviec",
        // meta: {},
        component: () => import("../pages/lichcongtac/danhSachCongViec"),
    },
    {
        path: "/sign-digital",
        name: "Lịch công tác",
        // meta: {},
        component: () => import("../pages/signDigital"),
    },
    {
        path: "/xem-lich-cong-tac/:loaiLichCongTac?",
        name: "Danh sách lịch công tác",
        // meta: {},
        component: () => import("../pages/lichcongtac/dsLichCongTac"),
    },
    {
        path: "/xac-nhan-ky-so",
        name: "Xác nhận ký số nội bộ",
        // meta: {},
        component: () => import("../pages/xacNhanKySo/pages"),
    },
    {
        path: "/thu-den",
        name: "ThuDen",
        component: () => import("../pages/hopThu/index"),
    },
    {
        path: "/thu-da-gui",
        name: "ThuDaGui",
        component: () => import("../pages/hopThu/thuDaGui"),
    },
    {
        path: "/thu-rac",
        name: "ThuRac",
        component: () => import("../pages/hopThu/thuRac"),
    },
    {
        path: "/thiet-lap-ky-so-phap-ly",
        name: "ThietLapKySoPhapLy",
        component: () => import("../pages/kySoPhapLy/thietLapKySo"),
    },
    {
        path: "/sig",
        name: "sig",
        component: () => import("../pages/kySoPhapLy/sig"),
    },
    {
        path: "/cong-van",
        name: "cong-van",
        component: () => import("../pages/congVan"),
    },
    {
        path: "/luu-cv-den",
        name: "cong-van-den",
        component: () => import("../pages/congVan/luuCVDen"),
    },
    {
        path: "/luu-cv-di",
        name: "cong-van-di",
        component: () => import("../pages/congVan/luuCVDi"),
    },
    {
        path: "/thong-tin-ky-so",
        name: "thong-tin-ky-so",
        component: () => import("../pages/kyso/thongTinKySo"),
    },
    {
        path: "/soan-van-ban-di/:id?",
        name: "soan-van-ban-di",
        component: () => import("../pages/vanbandi/soanvanban"),
    },
    {
        path: "/kspl-thiet-lap/:id?",
        name: "kspl-thietlap",
        component: () => import("../pages/kyso/kspl-thietlap"),
    },
    {
        path: "/ksnb-thiet-lap/:id?",
        name: "kspl-thietlap",
        component: () => import("../pages/kySoNoiBo/thietLapKySoNoiBo"),
    },
    {
        path: "/xem-tep-tin/:id?",
        name: "Xem tệp tin",
        component: () => import("../pages/ShowPDF"),
    },
    {
        path: "/hop-thu/chi-tiet/:id",
        name: "Xem hộp thu",
        component: () => import("../pages/hopThu/detail"),
    },
    {
        path: "/hop-thu/soan-thu/:id?",
        name: "Soạn thư",
        component: () => import("../pages/hopThu/soanThu"),
    },
    {
        path: "/hop-thu/tra-loi/:id?",
        name: "tra-loi",
        component: () => import("../pages/hopThu/soanThu"),
    },
    {
        path: "/hop-thu/tra-loi-tat-ca/:id?",
        name: "tra-loi-tat-ca",
        component: () => import("../pages/hopThu/soanThu"),
    },
    {
        path: "/hop-thu/chuyen-tiep/:id?",
        name: "chuyen-tiep",
        component: () => import("../pages/hopThu/soanThu"),
    },
    {
        path: "/thong-bao-cap-bo",
        name: "thong-bao-cap-bo",
        component: () => import("../pages/thongBao/capBo"),
    },
    {
        path: "/thong-bao-cap-tinh",
        name: "thong-bao-cap-tinh",
        component: () => import("../pages/thongBao/capTinh"),
    },
    {
        path: "/thong-bao-cap-truong",
        name: "thong-bao-cap-truong",
        component: () => import("../pages/thongBao/capTruong"),
    },
    {
        path: "/merge-thongbao",
        name: "merge-thongbao",
        component: () => import("../pages/thongBao/mergeThongBao"),
    },
    {
        path: "/quan-tri-thong-bao",
        name: "quanTriThongBao",
        component: () => import("../pages/quanTriNoiDung/quanTriThongBao"),
    },
    {
        path: "/quan-tri-hop-thu",
        name: "quanTriHopThu",
        component: () => import("../pages/quanTriNoiDung/quanTriHopThu"),
    },
    {
        path: "/quan-tri-thong-bao-admin",
        name: "QuanTriThongBaoAdmin",
        component: () => import("../pages/quanTriNoiDung/QuanLyThongBao/mergeThongBao.vue"),
    },
    {
        path: "/thiet-lap-ky-thay",
        name: "ThietLapKyThay",
        component: () => import("../pages/thietLapKyThay"),
    },
    {
        path: "/map-status",
        name: "MapStatus",
        component: () => import("../pages/mapStatus"),
    },
    {
        path: "/thong-tin-lien-lac",
        name: "ThongTinLienLac",
        component: () => import("../pages/thongTinLienLac"),
    },
    {
        path: "/doi-mat-khau",
        name: "DoiMatKhau",
        component: () => import("../router/layouts/LayoutChangePassword"),
    },
    {
        path: "/privacy-aparking",
        name: "privacy-aparking",
        component: () => import("../pages/privary-aparking"),
    },
    {
        path: "/privacy",
        name: "privacy",
        component: () => import("../pages/privacy/privacy"),
    },
    {
        path: "/term-of-use",
        name: "term-of-use",
        component: () => import("../pages/privacy/term_of_use"),
    },
    {
        path: "/ios-app-connector",
        name: "ios_app_connector",
        // meta: {},
        component: () => import("../pages/iosManagement/index.vue"),
    },
    {
        path: "/ios-management",
        name: "ios-management",
        // meta: {},
        component: () => import("../pages/iosManagement/manage.vue"),
    },
    {
        path: "/quan-ly-cong-viec",
        name: "quan-ly-cong-viec",
        // meta: {},
        component: () => import("../pages/quangLyCongViec/index.vue"),
    },
    {
        path: "/quan-ly-cong-viec/nhom-cong-viec/:id?",
        name: "quan-ly-cong-viec/nhom-cong-viec",
        // meta: {},
        component: () => import("../pages/quangLyCongViec/soanNhomCongViec.vue"),
    },
    {
        path: "/tien-do-cong-viec/:id?",
        name: "tien-do-cong-viec",
        // meta: {},
        component: () => import("../pages/quangLyCongViec/tienDoCongViec.vue"),
    },
    {
        path: "/tien-do-cong-viec/:groupId?/cong-viec/:id?",
        name: "tien-do-cong-viec/cong-viec",
        // meta: {},
        component: () => import("../pages/quangLyCongViec/soanTienDoCongViec.vue"),
    },
    {
        path: "/tham-dinh-van-ban/:id?",
        name: "tham-dinh-van-ban",
        component: () => import("../pages/thamDinhVanBan/thamDinhVanBan.vue"),
    },
    {
        path: "/quan-ly-sinh-vien",
        name: "quan-ly-sinh-vien",
        component: () => import("../pages/quanLySinhVien/quanLySinhVien.vue"),
    },
    {
        path: "/dang-ky-doffice",
        name: "dang-ky-tai-khoan-doffice",
        component: () => import("../pages/dangKyTaiKhoan/index.vue"),
    },
    {
        path: "/quan-ly-dang-ky-doffice",
        name: "quan-ly-dang-ky-doffice",
        component: () => import("../pages/dangKyTaiKhoan/quanLyDangKyTaiKhoan.vue"),
    },
]
